import React from 'react';

import { Icon } from 'core/components';
import { MdSettingsEthernet, MdRouter, MdDns } from 'react-icons/md';
import { FiGrid, FiTarget, FiGlobe, FiDollarSign, FiCloud, FiCpu } from 'react-icons/fi';
import { AiOutlineLineChart } from 'react-icons/ai';
import { GiRadarSweep } from 'react-icons/gi';
import { GoDatabase } from 'react-icons/go';
import { FaCompass } from 'react-icons/fa';
import { PiSparkleFill } from 'react-icons/pi';
import ASN from './ASN';
import CapacityPlan from './CapacityPlan';
import CDN from './CDN';
import CostGroup from './CostGroup';
import CostSnapshot from './CostSnapshot';
import Device from './Device';
import MetricDevice from './MetricDevice';
import Interface from './Interface';
import IP from './IP';
import OttProvider from './OttProvider';
import OttService from './OttService';
import OttType from './OttType';
import Provider from './Provider';
import AskAiAdvisor from './AskAiAdvisorResult';
import Site from './Site';
import Dashboard from './Dashboard';
import SavedView from './SavedView';
import Prefix from './Prefix';
import Filter from './SavedFilter';
import SyntheticTest from './SyntheticTest';
import Screen from './Screen';
import PortalPage from './PortalPage';

export const RESULT_TYPE_MAP = {
  asn: { name: 'asn', label: 'ASNs', Component: ASN, Icon: (props) => <Icon icon={FiTarget} {...props} /> },
  cdn: { name: 'cdn', label: 'CDNs', Component: CDN, Icon: (props) => <Icon icon={GoDatabase} {...props} /> },
  capacityPlan: {
    name: 'capacityPlan',
    label: 'Capacity Plans',
    Component: CapacityPlan,
    Icon: (props) => <Icon icon="search-around" {...props} />
  },
  costGroup: {
    name: 'costGroup',
    label: 'Cost Groups',
    Component: CostGroup,
    Icon: (props) => <Icon icon={FiDollarSign} {...props} />
  },
  costSnapshot: {
    name: 'costSnapshot',
    label: 'Cost Snapshots',
    Component: CostSnapshot,
    Icon: (props) => <Icon icon={FiDollarSign} {...props} />
  },
  dashboard: {
    name: 'dashboard',
    label: 'Dashboards',
    Component: Dashboard,
    Icon: (props) => <Icon icon={FiGrid} {...props} />
  },
  device: { name: 'device', label: 'Devices', Component: Device, Icon: (props) => <Icon icon={MdRouter} {...props} /> },
  interface: {
    name: 'interface',
    label: 'Interfaces',
    Component: Interface,
    Icon: (props) => <Icon icon={MdSettingsEthernet} {...props} />
  },
  ip: { name: 'ip', label: 'IP Addresses', Component: IP, Icon: (props) => <Icon icon="ip-address" {...props} /> },
  ips: { name: 'ips', label: 'IP Addresses', Component: IP, Icon: (props) => <Icon icon="ip-address" {...props} /> },
  metric_device: {
    name: 'metric_device',
    label: 'NMS Devices',
    Component: MetricDevice,
    Icon: (props) => <Icon icon={FiCpu} {...props} />
  },
  ottProvider: {
    name: 'ottProvider',
    label: 'OTT Providers',
    Component: OttProvider,
    Icon: (props) => <Icon icon={FiCloud} {...props} />
  },
  ottService: {
    name: 'ottService',
    label: 'OTT Services',
    Component: OttService,
    Icon: (props) => <Icon icon={MdDns} {...props} />
  },
  ottType: {
    name: 'ottType',
    label: 'OTT Types',
    Component: OttType,
    Icon: (props) => <Icon icon="help" {...props} />
  },
  prefix: {
    name: 'prefix',
    label: 'Prefixes',
    Component: Prefix,
    Icon: (props) => <Icon icon={FiTarget} {...props} />
  },
  provider: {
    name: 'provider',
    label: 'Providers',
    Component: Provider,
    Icon: (props) => <Icon icon={FiGlobe} {...props} />
  },
  savedFilter: {
    name: 'savedFilter',
    label: 'Saved Filters',
    Component: Filter,
    Icon: (props) => <Icon icon="filter" {...props} />
  },
  aiAdvisor: {
    name: 'aiAdvisor',
    label: 'Ask AI Advisor',
    Component: AskAiAdvisor,
    Icon: (props) => <Icon icon={PiSparkleFill} {...props} />,
    hideCategoryHeader: true
  },
  savedView: {
    name: 'savedView',
    label: 'Saved Views',
    Component: SavedView,
    Icon: (props) => <Icon icon={AiOutlineLineChart} {...props} />
  },
  site: { name: 'site', label: 'Sites', Component: Site, Icon: (props) => <Icon icon="map-marker" {...props} /> },
  syntheticTest: {
    name: 'syntheticTest',
    label: 'Synthetic Tests',
    Component: SyntheticTest,
    Icon: (props) => <Icon icon={GiRadarSweep} {...props} />
  },
  screen: { name: 'screen', label: 'Screens', Component: Screen },
  navigation: {
    name: 'navigation',
    label: 'Navigation',
    Component: PortalPage,
    Icon: (props) => <Icon icon={FaCompass} {...props} />
  }
};
